import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private readonly SESSION_STORAGE_KEY = 'app_version_banner_dismissed';
  private readonly TIMEOUT_DURATION = 900000; // 15 Minuten in Millisekunden

  private isOldAppVersionSubject = new BehaviorSubject<boolean>(false);
  public isOldAppVersion$ = this.isOldAppVersionSubject.asObservable();

  constructor() { }

  /**
   * Prüft einen HTTP-Response auf Version-Mismatch Header
   * und setzt ggf. das Old-Version-Flag
   */
  public checkResponseForVersionMismatch(response: HttpResponse<any>): void {
    const outdated = response.headers.get('x-app-version-outdated');
    if (outdated === 'true' && !this.isDismissed()) {
      this.setOldAppVersion();
    }
  }

  /**
   * Setzt das Flag, dass eine veraltete App-Version erkannt wurde
   */
  public setOldAppVersion(): void {
    this.isOldAppVersionSubject.next(true);
  }

  /**
   * Setzt das Flag zurück (z.B. nach Dismiss)
   */
  public resetOldAppVersion(): void {
    this.isOldAppVersionSubject.next(false);
  }

  /**
   * Prüft, ob der Banner aktuell dismissed ist (Timeout aktiv)
   */
  public isDismissed(): boolean {
    const dismissed = sessionStorage.getItem(this.SESSION_STORAGE_KEY);
    if (dismissed) {
      const timeout = parseInt(dismissed, 10);
      return Date.now() < timeout;
    }
    return false;
  }

  /**
   * Dismissed den Banner für 15 Minuten
   */
  public dismissBanner(): void {
    const timeout = Date.now() + this.TIMEOUT_DURATION;
    sessionStorage.setItem(this.SESSION_STORAGE_KEY, timeout.toString());
    this.resetOldAppVersion();
  }

  /**
   * Lädt die Seite neu
   */
  public reloadApp(): void {
    sessionStorage.removeItem(this.SESSION_STORAGE_KEY);
    window.location.reload();
  }
}
